import React from 'react';
import { Link, Stack } from '@mui/material';
import { SearchPeopleProfile } from 'modules/sourcing-external/types/SearchPeopleQueryItem';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { SourcingExternalTextBlock } from 'modules/sourcing-external/components/SourcingExternalTextBlock';
import { useTracking } from 'services/tracking/hooks';
import { TrackingEventName } from 'services/tracking/constants';
import { useSourcingExternalStore } from 'modules/sourcing-external/stores';

interface SourcingExternalContactOutProfileProps {
  profile: SearchPeopleProfile;
  hideLinkedInLink?: boolean;
}

export const SourcingExternalContactOutProfile: React.FC<
  SourcingExternalContactOutProfileProps
> = ({ profile, hideLinkedInLink = false }) => {
  const candidateBatch = useSourcingExternalStore(
    (state) => state.candidateBatch
  );
  const { track } = useTracking();

  return (
    <Stack gap="40px">
      {!hideLinkedInLink && (
        <Link
          href={profile.linkedInProfileUrl || undefined}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            p: 0,
            gap: '8px',
            width: 'fit-content',
            color: 'primary.main',
            fontWeight: 500,
            textDecoration: 'none',
            alignItems: 'center',
            display: 'flex'
          }}
          onClick={() =>
            profile.linkedInProfileUrl &&
            track(TrackingEventName.SourcingLinkedInProfileClick, {
              candidateBatchId: candidateBatch?.id,
              linkedInProfileUrl: profile.linkedInProfileUrl
            })
          }
        >
          View LinkedIn profile <OpenInNewIcon />
        </Link>
      )}
      <SourcingExternalTextBlock
        title="Experience"
        items={profile.experience || []}
      />
      <SourcingExternalTextBlock
        title="Education"
        items={profile.education || []}
      />
      <SourcingExternalTextBlock title="Skills" items={profile.skills || []} />
    </Stack>
  );
};
